import { useState } from "react"
import { Button } from "@/components/ui/button"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { useClientsContext } from "@/components/clients-context"
import { Plus, Building2, FolderOpen } from "lucide-react"
import { CreateClientDialog } from "./create-client-dialog"

interface ClientSelectorProps {
    value?: string | null
    onChange: (clientId: string | null) => void
    allowNone?: boolean
}

export function ClientSelector({ value, onChange, allowNone = true }: ClientSelectorProps) {
    const { clients, isLoading } = useClientsContext()
    const [showCreateDialog, setShowCreateDialog] = useState(false)

    return (
        <>
            <div className="space-y-2">
                <Select
                    value={value || "none"}
                    onValueChange={(val) => onChange(val === "none" ? null : val)}
                    disabled={isLoading}
                >
                    <SelectTrigger>
                        <SelectValue placeholder="Seleccionar cliente..." />
                    </SelectTrigger>
                    <SelectContent>
                        {allowNone && (
                            <SelectItem value="none">
                                <div className="flex items-center gap-2">
                                    <FolderOpen className="h-4 w-4 text-muted-foreground" />
                                    <span>Sin cliente (Proyecto interno)</span>
                                </div>
                            </SelectItem>
                        )}
                        {clients.map((client) => (
                            <SelectItem key={client.id} value={client.id}>
                                <div className="flex items-center gap-2">
                                    <Building2 className="h-4 w-4 text-muted-foreground" />
                                    <span>{client.name}</span>
                                </div>
                            </SelectItem>
                        ))}
                        <div className="border-t my-1" />
                        <div className="p-1">
                            <Button
                                variant="ghost"
                                size="sm"
                                className="w-full justify-start"
                                onClick={(e) => {
                                    e.preventDefault()
                                    setShowCreateDialog(true)
                                }}
                                type="button"
                            >
                                <Plus className="h-4 w-4 mr-2" />
                                Crear nuevo cliente
                            </Button>
                        </div>
                    </SelectContent>
                </Select>
            </div>

            <CreateClientDialog
                open={showCreateDialog}
                onOpenChange={setShowCreateDialog}
                onClientCreated={(client) => {
                    onChange(client.id)
                    setShowCreateDialog(false)
                }}
            />
        </>
    )
}
